import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, labeledIntro, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** blog — latest-posts heading and link; post cards are populated by the host CMS. */
export function renderBlog(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const blogUrl = str(section.fields, 'blog_url');
  const viewAllLabel = str(section.fields, 'view_all_label');
  const parts: string[] = [sectionOpen(section), ...labeledIntro(section, 'blog', heading, label)];
  parts.push('  <div class="ve-blog__posts"></div>');
  if (viewAllLabel && blogUrl) {
    parts.push(`  <a class="ve-blog__view-all" href="${safeUrl(blogUrl)}"${editAttr(section, '/view_all_label')}>${escapeHtml(viewAllLabel)}</a>`);
  }
  parts.push('</section>');
  return parts.join('\n');
}
